/**
 * @author Yaochao
 * @date 2021/8/3 12:05
 * @description
 */
import React from 'react'
import {Route} from "react-router-dom";
import loadable from "../loadable";
import CorpBaseConfig from "./corp/corpBaseConfig";
import Utils from "../public/utils";
import noPermissions from "./noPermissions/noPermissions";
import PubSub from "pubsub-js";
import {connect} from "react-redux";

const MarketConfig = loadable(() => import('../market/config/index'));
const MpConfig = loadable(() => import('../market/config/oaconfig/oa_config'));
const WxPayConfig = loadable(() => import('../market/config/pay/payAdd'));
const CorpConfigManage = loadable(() => import('./corp/manage'));
const MemberConfig = loadable(() => import('./member/member'))

class ConfigManage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <>
                {
                    this.props.subInfo.isSub == 0 ?
                        <>
                            <Route path={this.props.match.url + "/market/:id"} component={MarketConfig}/>
                            <Route path={this.props.match.url + "/mp"} component={MpConfig}/>
                            <Route path={this.props.match.url + "/wxpay"} component={WxPayConfig}/>
                            <Route path={this.props.match.url + "/corp/manage"} component={CorpBaseConfig(CorpConfigManage)}/>
                            <Route path={this.props.match.url + "/member"} component={CorpBaseConfig(MemberConfig)}/>
                        </> : this.props.subInfo.isSub == 1 ?
                        <>
                            <Route path={this.props.match.url + "/market/:id"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'marketSetting','marketSetting_brand') ?
                                       MarketConfig : noPermissions}/>
                            <Route path={this.props.match.url + "/mp"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'marketSetting','marketSetting_mp') ?
                                       MpConfig :noPermissions}/>
                            <Route path={this.props.match.url + "/wxpay"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'marketSetting','marketSetting_wxpay') ?
                                       WxPayConfig : noPermissions}/>
                            <Route path={this.props.match.url + "/corp/manage"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'marketSetting','marketSetting_corpManage') ?
                                       CorpBaseConfig(CorpConfigManage) : noPermissions}/>
                            <Route path={this.props.match.url + "/member"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'marketSetting','marketSetting_member') ?
                                       CorpBaseConfig(MemberConfig) : noPermissions}/>
                        </> : <></>
                }

            </>
        )
    }
}

export default connect(state=>{
    const {subReducer} = state
    return {
        subInfo : subReducer
    }
},null)(ConfigManage)